/**
 * Debug logging utility
 *
 * Wraps console methods to only output in development mode.
 * In production builds, these calls are no-ops.
 *
 * Usage:
 *   import { debugLog, debugWarn, debugError } from '../util/debug';
 *   debugLog('[Component]', 'Message', data);
 */

const isDev = process.env.NODE_ENV === 'development';

export const debugLog = (...args) => {
  if (isDev) {
    console.log(...args);
  }
};

export const debugWarn = (...args) => {
  if (isDev) {
    console.warn(...args);
  }
};

export const debugInfo = (...args) => {
  if (isDev) {
    console.info(...args);
  }
};

// Note: console.error is NOT wrapped - errors should always be logged
// Use debugError only for non-critical debug messages that happen to use error styling
export const debugError = (...args) => {
  if (isDev) {
    console.error(...args);
  }
};

const debug = { debugLog, debugWarn, debugInfo, debugError };

export default debug;
